var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { isRow } from '../../types/node';
/** */
var findNode = function (nodes, nodeId, ancestors) {
    var e_1, _a;
    if (ancestors === void 0) { ancestors = []; }
    try {
        for (var nodes_1 = __values(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
            var node = nodes_1_1.value;
            if (node.id === nodeId) {
                return {
                    node: node,
                    ancestors: ancestors,
                };
            }
            // else search children
            if (isRow(node) && node.cells) {
                var found = findNode(node.cells, nodeId, __spread([node], ancestors));
                if (found) {
                    return found;
                }
            }
            else if (!isRow(node) && node.rows) {
                var found = findNode(node.rows, nodeId, __spread([node], ancestors));
                if (found) {
                    return found;
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return null;
};
/*
let sum = 0;
let missum = 0;
const end = (start, hit) => {
  const now = performance.now();
  const diff = now - start;
  sum += diff;
  if (!hit) missum++;
  console.log('time', hit ? '!' : '?', missum, diff, sum);
};
*/
export var findNodeInState = function (state, nodeId) {
    var _a, _b;
    // const now = performance.now();
    // POOR mans node cache
    // it gets removed every reduce, so we don't have to clear it manually
    if (!state.reactPage.__nodeCache) {
        state.reactPage.__nodeCache = {};
    }
    if (state.reactPage.__nodeCache[nodeId]) {
        //end(now, true);
        return state.reactPage.__nodeCache[nodeId];
    }
    var result = findNode((_b = (_a = state.reactPage.values) === null || _a === void 0 ? void 0 : _a.present) === null || _b === void 0 ? void 0 : _b.rows, nodeId);
    state.reactPage.__nodeCache[nodeId] = result;
    //end(now, false);
    return result;
};
export var currentValue = function (state) { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.reactPage) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.present; };
export var selectNode = function (state, nodeId) {
    var found = findNodeInState(state, nodeId);
    return found;
};
//# sourceMappingURL=index.js.map